import { Component, OnInit, Input } from '@angular/core';
import { CommitteeMeetingDto } from '../../shared/dto/committee-meeting.dto';
import { ControlContainer, NgForm } from '@angular/forms';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-committee-meeting-details-edit',
  templateUrl: './committee-meeting-details-edit.component.html',
  styleUrls: ['./committee-meeting-details-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class CommitteeMeetingDetailsEditComponent implements OnInit {
  @Input() committeeMeeting: CommitteeMeetingDto;

  constructor() {}

  ngOnInit(): void {}
}
